import React from 'react';
import { Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { enhancedConnect } from "../../../../utils";
import styles from "./styles.pcss";
import { StoreLinkList } from "../StoreLinkList";
import { DEFAULT_APP_BLOCK } from "../../constants";
var cx = classNames.bind(styles);
var _StoresBlock = function _StoresBlock(_ref) {
  var qrLabel = _ref.qrLabel,
    qrImageUrl = _ref.qrImageUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('store-wrapper'),
    "data-t-id": "components-StoresBlock"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('store-qr')
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cx('store-image'),
    src: qrImageUrl
  }), /*#__PURE__*/React.createElement(Text, {
    align: "center",
    className: cx('store-label'),
    color: "tertiary",
    variant: "body-small"
  }, qrLabel)), /*#__PURE__*/React.createElement("div", {
    className: cx('stores-links')
  }, /*#__PURE__*/React.createElement(StoreLinkList, null)));
};
export var StoresBlock = enhancedConnect({
  qrImageUrl: PropTypes.string,
  qrLabel: PropTypes.string
})(_StoresBlock);
StoresBlock.defaultProps = {
  qrImageUrl: DEFAULT_APP_BLOCK.store.qr.qrImageUrl,
  qrLabel: DEFAULT_APP_BLOCK.store.qr.qrLabel
};